function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("moment"), require("react")) : "function" == typeof define && define.amd ? define(["moment", "react"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["react-moment"] = t(require("moment"), require("react")) : e["react-moment"] = t(e.moment, e.react);
}(this, function (e, t) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "", t(0);
  }([function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        c = n(13),
        f = r(c),
        s = n(11),
        p = r(s),
        d = n(12),
        y = r(d),
        m = n(6),
        v = [p["default"].string, p["default"].number, p["default"].array, p["default"].object],
        h = [p["default"].string, p["default"].array],
        b = [p["default"].object, p["default"].bool],
        g = function (e) {
      function t(e) {
        o(this, t);
        var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.setTimer = function () {
          n.clearTimer();
          var e = n.props.interval;
          t.pooledTimer || 0 === e || (n.timer = setInterval(function () {
            n.update(n.props);
          }, e));
        }, n.clearTimer = function () {
          !t.pooledTimer && n.timer && (clearInterval(n.timer), n.timer = null), t.pooledTimer && !n.timer && t.removePooledElement(n);
        }, t.globalMoment || (t.globalMoment = y["default"]), n.state = {
          content: ""
        }, n.timer = null, n;
      }

      return a(t, e), l(t, null, [{
        key: "startPooledTimer",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e4;
          t.clearPooledTimer(), t.pooledTimer = setInterval(function () {
            t.pooledElements.forEach(function (e) {
              0 !== e.props.interval && e.update();
            });
          }, e);
        }
      }, {
        key: "clearPooledTimer",
        value: function value() {
          t.pooledTimer && (clearInterval(t.pooledTimer), t.pooledTimer = null, t.pooledElements = []);
        }
      }, {
        key: "pushPooledElement",
        value: function value(e) {
          return e instanceof t ? void (t.pooledElements.indexOf(e) === -1 && t.pooledElements.push(e)) : void console.error("Element not an instance of Moment.");
        }
      }, {
        key: "removePooledElement",
        value: function value(e) {
          var n = t.pooledElements.indexOf(e);
          n !== -1 && t.pooledElements.splice(n, 1);
        }
      }, {
        key: "getDatetime",
        value: function value(e) {
          var n = e.utc,
              r = e.unix,
              o = e.tz,
              i = e.date,
              a = e.locale,
              u = e.parse;
          i = i || e.children, u = u || t.globalParse, a = t.globalLocale ? t.globalLocale : a || t.globalMoment.locale();
          var l = null;
          return l = n ? t.globalMoment.utc(i, u, a) : r ? t.globalMoment(1e3 * i, u, a) : t.globalMoment(i, u, a), o && (l = l.tz(o)), l;
        }
      }]), l(t, [{
        key: "componentWillMount",
        value: function value() {
          this.update(this.props);
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          this.setTimer(), t.pooledTimer && t.pushPooledElement(this);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.update(e);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          e.interval !== this.props.interval && this.setTimer();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.clearTimer();
        }
      }, {
        key: "update",
        value: function value(e) {
          var n = this;
          e = e || this.props;
          var r = e,
              o = r.fromNow,
              i = r.from,
              a = r.add,
              u = r.subtract,
              l = r.toNow,
              c = r.to,
              f = r.ago,
              s = r.calendar,
              p = r.diff,
              d = r.unit,
              y = r.decimal,
              m = e,
              v = m.format;
          v = v || t.globalFormat;
          var h = t.getDatetime(e);
          a && h.add(a), u && h.subtract(u);
          var b = "";
          b = v ? h.format(v) : i ? h.from(i, f) : o ? h.fromNow(f) : c ? h.to(c, f) : l ? h.toNow(f) : s ? h.calendar(null, s) : p ? h.diff(p, d, y) : h.toString();
          var g = t.globalFilter || this.props.filter;
          b = g(b), this.setState({
            content: b
          }, function () {
            n.props.onChange(b);
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = (0, m.objectKeyFilter)(this.props, t.propTypes);
          return f["default"].createElement(t.globalElement || this.props.element, u({
            dateTime: t.getDatetime(this.props)
          }, e), this.state.content);
        }
      }]), t;
    }(f["default"].Component);

    g.propTypes = {
      element: p["default"].any,
      date: p["default"].oneOfType(v),
      parse: p["default"].oneOfType(h),
      format: p["default"].string,
      add: p["default"].object,
      subtract: p["default"].object,
      ago: p["default"].bool,
      fromNow: p["default"].bool,
      from: p["default"].oneOfType(v),
      toNow: p["default"].bool,
      to: p["default"].oneOfType(v),
      calendar: p["default"].oneOfType(b),
      unix: p["default"].bool,
      utc: p["default"].bool,
      tz: p["default"].string,
      locale: p["default"].string,
      interval: p["default"].number,
      diff: p["default"].oneOfType(v),
      unit: p["default"].string,
      decimal: p["default"].bool,
      filter: p["default"].func,
      onChange: p["default"].func
    }, g.defaultProps = {
      element: "time",
      fromNow: !1,
      toNow: !1,
      calendar: !1,
      ago: !1,
      unix: !1,
      utc: !1,
      unit: null,
      decimal: !1,
      interval: 6e4,
      filter: function filter(e) {
        return e;
      },
      onChange: function onChange() {}
    }, g.globalMoment = null, g.globalLocale = null, g.globalFormat = null, g.globalParse = null, g.globalFilter = null, g.globalElement = null, g.pooledElements = [], g.pooledTimer = null, t["default"] = g;
  }, function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }

    function r() {
      throw new Error("clearTimeout has not been defined");
    }

    function o(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(e, 0);

      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }

    function i(e) {
      if (s === clearTimeout) return clearTimeout(e);
      if ((s === r || !s) && clearTimeout) return s = clearTimeout, clearTimeout(e);

      try {
        return s(e);
      } catch (t) {
        try {
          return s.call(null, e);
        } catch (t) {
          return s.call(this, e);
        }
      }
    }

    function a() {
      m && d && (m = !1, d.length ? y = d.concat(y) : v = -1, y.length && u());
    }

    function u() {
      if (!m) {
        var e = o(a);
        m = !0;

        for (var t = y.length; t;) {
          for (d = y, y = []; ++v < t;) {
            d && d[v].run();
          }

          v = -1, t = y.length;
        }

        d = null, m = !1, i(e);
      }
    }

    function l(e, t) {
      this.fun = e, this.array = t;
    }

    function c() {}

    var f,
        s,
        p = e.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        f = n;
      }

      try {
        s = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        s = r;
      }
    }();
    var d,
        y = [],
        m = !1,
        v = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      y.push(new l(e, t)), 1 !== y.length || m || o(u);
    }, l.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t) {
    "use strict";

    function n(e) {
      return function () {
        return e;
      };
    }

    var r = function r() {};

    r.thatReturns = n, r.thatReturnsFalse = n(!1), r.thatReturnsTrue = n(!0), r.thatReturnsNull = n(null), r.thatReturnsThis = function () {
      return this;
    }, r.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = r;
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      function n(e, t, n, o, i, a, u, l) {
        if (r(t), !e) {
          var c;
          if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
            var f = [n, o, i, a, u, l],
                s = 0;
            c = new Error(t.replace(/%s/g, function () {
              return f[s++];
            })), c.name = "Invariant Violation";
          }
          throw c.framesToPop = 1, c;
        }
      }

      var r = function r(e) {};

      "production" !== t.env.NODE_ENV && (r = function r(e) {
        if (void 0 === e) throw new Error("invariant requires an error message argument");
      }), e.exports = n;
    }).call(t, n(1));
  }, function (e, t) {
    "use strict";

    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    e.exports = n;
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      var r = n(2),
          o = r;

      if ("production" !== t.env.NODE_ENV) {
        var i = function i(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          var o = 0,
              i = "Warning: " + e.replace(/%s/g, function () {
            return n[o++];
          });
          "undefined" != typeof console && console.error(i);

          try {
            throw new Error(i);
          } catch (e) {}
        };

        o = function o(e, t) {
          if (void 0 === t) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");

          if (0 !== t.indexOf("Failed Composite propType: ") && !e) {
            for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) {
              r[o - 2] = arguments[o];
            }

            i.apply(void 0, [t].concat(r));
          }
        };
      }

      e.exports = o;
    }).call(t, n(1));
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      var n = Object.keys(t),
          r = Object.assign({}, e);
      return Object.keys(r).filter(function (e) {
        return n.indexOf(e) !== -1;
      }).forEach(function (e) {
        return delete r[e];
      }), r;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.objectKeyFilter = n;
  }, function (e, t) {
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    "use strict";

    function n(e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }

    function r() {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        var r = Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        });
        if ("0123456789" !== r.join("")) return !1;
        var o = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          o[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
      } catch (e) {
        return !1;
      }
    }

    var o = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        a = Object.prototype.propertyIsEnumerable;
    e.exports = r() ? Object.assign : function (e, t) {
      for (var r, u, l = n(e), c = 1; c < arguments.length; c++) {
        r = Object(arguments[c]);

        for (var f in r) {
          i.call(r, f) && (l[f] = r[f]);
        }

        if (o) {
          u = o(r);

          for (var s = 0; s < u.length; s++) {
            a.call(r, u[s]) && (l[u[s]] = r[u[s]]);
          }
        }
      }

      return l;
    };
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      function r(e, n, r, l, c) {
        if ("production" !== t.env.NODE_ENV) for (var f in e) {
          if (e.hasOwnProperty(f)) {
            var s;

            try {
              o("function" == typeof e[f], "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", l || "React class", r, f, _typeof(e[f])), s = e[f](n, f, l, r, null, a);
            } catch (e) {
              s = e;
            }

            if (i(!s || s instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", r, f, _typeof(s)), s instanceof Error && !(s.message in u)) {
              u[s.message] = !0;
              var p = c ? c() : "";
              i(!1, "Failed %s type: %s%s", r, s.message, null != p ? p : "");
            }
          }
        }
      }

      if ("production" !== t.env.NODE_ENV) var o = n(3),
          i = n(5),
          a = n(4),
          u = {};
      e.exports = r;
    }).call(t, n(1));
  }, function (e, t, n) {
    "use strict";

    var r = n(2),
        o = n(3),
        i = n(4);

    e.exports = function () {
      function e(e, t, n, r, a, u) {
        u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    (function (t) {
      "use strict";

      var r = n(2),
          o = n(3),
          i = n(5),
          a = n(7),
          u = n(4),
          l = n(8);

      e.exports = function (e, n) {
        function c(e) {
          var t = e && (R && e[R] || e[I]);
          if ("function" == typeof t) return t;
        }

        function f(e, t) {
          return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
        }

        function s(e) {
          this.message = e, this.stack = "";
        }

        function p(e) {
          function r(r, c, f, p, d, y, m) {
            if (p = p || S, y = y || f, m !== u) if (n) o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");else if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
              var v = p + ":" + f;
              !a[v] && l < 3 && (i(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", y, p), a[v] = !0, l++);
            }
            return null == c[f] ? r ? new s(null === c[f] ? "The " + d + " `" + y + "` is marked as required " + ("in `" + p + "`, but its value is `null`.") : "The " + d + " `" + y + "` is marked as required in " + ("`" + p + "`, but its value is `undefined`.")) : null : e(c, f, p, d, y);
          }

          if ("production" !== t.env.NODE_ENV) var a = {},
              l = 0;
          var c = r.bind(null, !1);
          return c.isRequired = r.bind(null, !0), c;
        }

        function d(e) {
          function t(t, n, r, o, i, a) {
            var u = t[n],
                l = P(u);

            if (l !== e) {
              var c = k(u);
              return new s("Invalid " + o + " `" + i + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."));
            }

            return null;
          }

          return p(t);
        }

        function y() {
          return p(r.thatReturnsNull);
        }

        function m(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new s("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var a = t[n];

            if (!Array.isArray(a)) {
              var l = P(a);
              return new s("Invalid " + o + " `" + i + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an array."));
            }

            for (var c = 0; c < a.length; c++) {
              var f = e(a, c, r, o, i + "[" + c + "]", u);
              if (f instanceof Error) return f;
            }

            return null;
          }

          return p(t);
        }

        function v() {
          function t(t, n, r, o, i) {
            var a = t[n];

            if (!e(a)) {
              var u = P(a);
              return new s("Invalid " + o + " `" + i + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected a single ReactElement."));
            }

            return null;
          }

          return p(t);
        }

        function h(e) {
          function t(t, n, r, o, i) {
            if (!(t[n] instanceof e)) {
              var a = e.name || S,
                  u = _(t[n]);

              return new s("Invalid " + o + " `" + i + "` of type " + ("`" + u + "` supplied to `" + r + "`, expected ") + ("instance of `" + a + "`."));
            }

            return null;
          }

          return p(t);
        }

        function b(e) {
          function n(t, n, r, o, i) {
            for (var a = t[n], u = 0; u < e.length; u++) {
              if (f(a, e[u])) return null;
            }

            var l = JSON.stringify(e);
            return new s("Invalid " + o + " `" + i + "` of value `" + a + "` " + ("supplied to `" + r + "`, expected one of " + l + "."));
          }

          return Array.isArray(e) ? p(n) : ("production" !== t.env.NODE_ENV ? i(!1, "Invalid argument supplied to oneOf, expected an instance of array.") : void 0, r.thatReturnsNull);
        }

        function g(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new s("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var a = t[n],
                l = P(a);
            if ("object" !== l) return new s("Invalid " + o + " `" + i + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));

            for (var c in a) {
              if (a.hasOwnProperty(c)) {
                var f = e(a, c, r, o, i + "." + c, u);
                if (f instanceof Error) return f;
              }
            }

            return null;
          }

          return p(t);
        }

        function O(e) {
          function n(t, n, r, o, i) {
            for (var a = 0; a < e.length; a++) {
              var l = e[a];
              if (null == l(t, n, r, o, i, u)) return null;
            }

            return new s("Invalid " + o + " `" + i + "` supplied to " + ("`" + r + "`."));
          }

          if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV ? i(!1, "Invalid argument supplied to oneOfType, expected an instance of array.") : void 0, r.thatReturnsNull;

          for (var o = 0; o < e.length; o++) {
            var a = e[o];
            if ("function" != typeof a) return i(!1, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", N(a), o), r.thatReturnsNull;
          }

          return p(n);
        }

        function T() {
          function e(e, t, n, r, o) {
            return j(e[t]) ? null : new s("Invalid " + r + " `" + o + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
          }

          return p(e);
        }

        function w(e) {
          function t(t, n, r, o, i) {
            var a = t[n],
                l = P(a);
            if ("object" !== l) return new s("Invalid " + o + " `" + i + "` of type `" + l + "` " + ("supplied to `" + r + "`, expected `object`."));

            for (var c in e) {
              var f = e[c];

              if (f) {
                var p = f(a, c, r, o, i + "." + c, u);
                if (p) return p;
              }
            }

            return null;
          }

          return p(t);
        }

        function E(e) {
          function t(t, n, r, o, i) {
            var l = t[n],
                c = P(l);
            if ("object" !== c) return new s("Invalid " + o + " `" + i + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
            var f = a({}, t[n], e);

            for (var p in f) {
              var d = e[p];
              if (!d) return new s("Invalid " + o + " `" + i + "` key `" + p + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var y = d(l, p, r, o, i + "." + p, u);
              if (y) return y;
            }

            return null;
          }

          return p(t);
        }

        function j(t) {
          switch (_typeof(t)) {
            case "number":
            case "string":
            case "undefined":
              return !0;

            case "boolean":
              return !t;

            case "object":
              if (Array.isArray(t)) return t.every(j);
              if (null === t || e(t)) return !0;
              var n = c(t);
              if (!n) return !1;
              var r,
                  o = n.call(t);

              if (n !== t.entries) {
                for (; !(r = o.next()).done;) {
                  if (!j(r.value)) return !1;
                }
              } else for (; !(r = o.next()).done;) {
                var i = r.value;
                if (i && !j(i[1])) return !1;
              }

              return !0;

            default:
              return !1;
          }
        }

        function x(e, t) {
          return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
        }

        function P(e) {
          var t = _typeof(e);

          return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : x(t, e) ? "symbol" : t;
        }

        function k(e) {
          if ("undefined" == typeof e || null === e) return "" + e;
          var t = P(e);

          if ("object" === t) {
            if (e instanceof Date) return "date";
            if (e instanceof RegExp) return "regexp";
          }

          return t;
        }

        function N(e) {
          var t = k(e);

          switch (t) {
            case "array":
            case "object":
              return "an " + t;

            case "boolean":
            case "date":
            case "regexp":
              return "a " + t;

            default:
              return t;
          }
        }

        function _(e) {
          return e.constructor && e.constructor.name ? e.constructor.name : S;
        }

        var R = "function" == typeof Symbol && Symbol.iterator,
            I = "@@iterator",
            S = "<<anonymous>>",
            D = {
          array: d("array"),
          bool: d("boolean"),
          func: d("function"),
          number: d("number"),
          object: d("object"),
          string: d("string"),
          symbol: d("symbol"),
          any: y(),
          arrayOf: m,
          element: v(),
          instanceOf: h,
          node: T(),
          objectOf: g,
          oneOf: b,
          oneOfType: O,
          shape: w,
          exact: E
        };
        return s.prototype = Error.prototype, D.checkPropTypes = l, D.PropTypes = D, D;
      };
    }).call(t, n(1));
  }, function (e, t, n) {
    (function (t) {
      if ("production" !== t.env.NODE_ENV) {
        var r = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103,
            o = function o(e) {
          return "object" == _typeof(e) && null !== e && e.$$typeof === r;
        },
            i = !0;

        e.exports = n(10)(o, i);
      } else e.exports = n(9)();
    }).call(t, n(1));
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }]);
});